<template>
  <vuetify-dialog :ref="reference" :title="title" :button="button" :show="show" :closeable="closeable" @submit="submit">
    <div>
      <v-container class="py-0" v-if="info">
        <v-layout row>
          <div class="flex xs12">
            <v-alert v-model="info" dismissible type="success" outline class="v-alert--no-icon">
              Your credit card will not be charged without your prior express consent, and we will email you a few days before applying a charge. If you decide that NextLead isn't for you, you can cancel and remove card from your account at any time.
            </v-alert>
          </div>
        </v-layout>
      </v-container>
    </div>
    <v-form>
      <v-container class="px-0">
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              name="name"
              v-model.trim="name"
              label="Cardholder Name"
              placeholder="Full Name"
              required
              data-vv-as="Name"
              v-validate="'required'"
              :error-messages="getError('name')"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <div class="v-input v-text-field v-text-field--placeholder theme--light" :class="{'v-input--is-focused primary--text': cardNumberInFocus}">
              <div class="v-input__control">
                <div class="v-input__slot">
                  <div class="v-text-field__slot">
                    <label for="card-number"
                           class="v-label v-label--active theme--light"
                           style="left: 0px; right: auto; position: absolute;"
                           :class="{'error--text': errorMessage.cardNumberError, 'primary--text': cardNumberInFocus}">Card Number</label>
                    <div id="card-number" class="stripe_element"></div>
                  </div>
                  <div class="v-input__append-inner">
                    <div class="v-input__icon v-input__icon--append">
                      <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                    </div>
                  </div>
                </div>
                <div class="v-text-field__details"  >
                  <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">{{errorMessage.cardNumberError}}</div>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs6>
            <div class="v-input v-text-field v-text-field--placeholder theme--light" :class="{'v-input--is-focused primary--text': cardExpiryInFocus}">
              <div class="v-input__control">
                <div class="v-input__slot">
                  <div class="v-text-field__slot">
                    <label for="card-expiry"
                           class="v-label v-label--active theme--light"
                           style="left: 0px; right: auto; position: absolute;"
                           :class="{'error--text': errorMessage.cardExpiryError, 'primary--text': cardExpiryInFocus}">Expiration</label>
                    <div id="card-expiry" class="stripe_element"></div>
                  </div>
                  <div class="v-input__append-inner">
                    <div class="v-input__icon v-input__icon--append">
                      <i aria-hidden="true" class="v-icon material-icons theme--light">today</i>
                    </div>
                  </div>
                </div>
                <div class="v-text-field__details">
                  <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">{{errorMessage.cardExpiryError}}</div>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="v-input v-text-field v-text-field--placeholder theme--light" :class="{'v-input--is-focused primary--text': cardCvcInFocus}">
              <div class="v-input__control">
                <div class="v-input__slot">
                  <div class="v-text-field__slot">
                    <label for="card-cvc"
                           class="v-label v-label--active theme--light"
                           style="left: 0px; right: auto; position: absolute;"
                           :class="{'error--text': errorMessage.cardCVCError, 'primary--text': cardCvcInFocus}">CVC</label>
                    <div id="card-cvc" class="stripe_element"></div>
                  </div>
                  <div class="v-input__append-inner">
                    <div class="v-input__icon v-input__icon--append">
                      <i aria-hidden="true" class="v-icon material-icons theme--light">verified_user</i>
                    </div>
                  </div>
                </div>
                <div class="v-text-field__details">
                  <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">{{errorMessage.cardCVCError}}</div>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>
          <!--<v-flex xs12 sm4>-->
            <!--<v-text-field-->
              <!--name="zip"-->
              <!--v-model.trim="zip"-->
              <!--label="Billing Zip/Postal Code"-->
              <!--placeholder="Zip/Postal Code"-->
              <!--required-->
              <!--data-vv-as="Zip/Postal Code"-->
              <!--v-validate="'required|min:5'"-->
              <!--:error-messages="getError('zip')"-->
              <!--append-icon="place"-->
            <!--&gt;</v-text-field>-->
          <!--</v-flex>-->
        </v-layout>
      </v-container>
    </v-form>
    <div class="pa-2 mb-3 text-xs-center">
      <v-btn class="v-btn v-btn--large theme--dark success"
             target="_blank" @click="submit">
        {{button}}
      </v-btn>
    </div>
  </vuetify-dialog>
</template>
<script>
import VuetifyDialog from '@/components/VuetifyDialog';
/* eslint-disable no-undef */
const stripe = Stripe(process.env.STRIPE_PUBLISHABLE_KEY);

const style = {
  base: {
    color: '#54667a',
    fontSize: '16px',
    lineHeight: '20px',
    '::placeholder': {
      color: '#E0E0E0',
    },
  },
  invalid: {
    color: '#e25950',
  },
};

const elementClasses = {
  focus: 'focused',
  empty: 'empty',
  invalid: 'invalid',
};

const elementOptions = {
  style,
  classes: elementClasses,
};

export default {
  components: {
    VuetifyDialog,
  },
  props: {
    title: { type: String, default: "" },
    button: { type: String, default: "Next" },
    closeable: { type: Boolean, default: false },
    reference: { type: String, default: "modal" },
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      zip: '',
      name: '',
      errorMessage: {},
      showSpinner: 0,
      isValid: true,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      cardNumberInFocus: false,
      cardExpiryInFocus: false,
      cardCvcInFocus: false,
      info: true
    };
  },
  mounted() {
    const elements = stripe.elements();

    this.cardNumber = elements.create('cardNumber', {...elementOptions, placeholder: 'XXXX XXXX XXXX XXXX'});
    this.cardExpiry = elements.create('cardExpiry', elementOptions);
    this.cardCvc = elements.create('cardCvc', elementOptions);


    setTimeout(() => {
      this.cardNumber.mount('#card-number');
      this.cardExpiry.mount('#card-expiry');
      this.cardCvc.mount('#card-cvc');

      this.cardNumber.on('focus', (event) => {
        this.onFocus(event);
      });
      this.cardExpiry.on('focus', (event) => {
        this.onFocus(event);
      });
      this.cardCvc.on('focus', (event) => {
        this.onFocus(event);
      });
      this.cardNumber.on('blur', (event) => {
        this.onBlur(event);
      });
      this.cardExpiry.on('blur', (event) => {
        this.onBlur(event);
      });
      this.cardCvc.on('blur', (event) => {
        this.onBlur(event);
      });
    }, 1000);

  },
  methods: {
    getError(name) {
      return this.isValid ? '' : this.errors.first(name);
    },
    onFocus(event) {
      switch(event.elementType) {
        case "cardNumber":
          this.cardNumberInFocus = true;
          break;
        case "cardExpiry":
          this.cardExpiryInFocus = true;
          break;
        case "cardCvc":
          this.cardCvcInFocus = true;
          break;
        default:
      }
    },
    onBlur(event) {
      switch(event.elementType) {
        case "cardNumber":
          this.cardNumberInFocus = false;
          break;
        case "cardExpiry":
          this.cardExpiryInFocus = false;
          break;
        case "cardCvc":
          this.cardCvcInFocus = false;
          break;
        default:
      }
    },
    cardHandler({ error }) {
      if (error) {
        this.errorMessage = {};
        if (error.code === 'incomplete_number' || error.code === 'invalid_number' || error.code === 'incorrect_number' || error.code === 'invalid_card_type' || error.code === 'card_declined') {
          this.errorMessage.cardNumberError = error.message;
        } else if (error.code === 'incomplete_cvc' || error.code === 'invalid_cvc' || error.code === 'incorrect_cvc') {
          this.errorMessage.cardCVCError = error.message;
        } else if (error.code === 'incomplete_expiry' || error.code === 'expired_card' || error.code === 'invalid_expiry_month' || error.code === 'invalid_expiry_year' || error.code === 'invalid_expiry_year_past') {
          this.errorMessage.cardExpiryError = error.message;
        } else {
          this.errorMessage.cardNumberError = error.message;
        }
      } else {
        this.errorMessage = {};
      }
    },
    async submit() {
      const options = {};

      this.isValid = await this.$validator.validateAll();
      const token = await stripe.createToken(this.cardNumber, options);

      try {
        this.cardHandler(token);
      } catch (error) {
        /* eslint-disable no-console */
        console.error('Error', error);
        return null;
      }

      if (!this.isValid || token.error) {
        return null;
      }

      // this.$refs.modal.close();
      // this.createCard(token.token.id);
      this.$emit('submit', {
        name: this.name,
        token: token.token,
      });

    },
  },
};
</script>
<style scoped lang="scss">
  .stripe_element {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    line-height: 20px;
    padding: 8px 0;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    max-height: 32px;
    color: rgba(0,0,0,.87);
    margin: 0;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Signup/Payment.vue